import React from "react";
import { Card, CardBody, Heading, Text, VStack } from "@chakra-ui/react";

const WorkbookEmptyState = ({ title, description }) => {
  return (
    <Card borderRadius="2xl" borderWidth="1px" borderColor="gray.200">
      <CardBody py={10}>
        <VStack spacing={3} align="center" textAlign="center">
          <Heading size="md">{title}</Heading>
          <Text color="gray.600" maxW="2xl">
            {description}
          </Text>
        </VStack>
      </CardBody>
    </Card>
  );
};

export default WorkbookEmptyState;
